<div class="front-change-park-section">
    <form [formGroup]="fmPark">
        <div class="form-park">
            <label class="title">{{ "park" | lang }}</label>
            <div class="d-flex m-0 p-0 park-selector">
                <app-dropdown-selector
                    class="aps-park-selector"
                    formControlName="selectPark"
                    *ngIf="parkZone"
                    [label]="' '"
                    placeholder="{{ 'select-park' | lang }}"
                    [isDisabled]="parkZone.length === 1 ? true : false"
                    [items]="parkZone"
                    bindLabel="name"
                    bindValue="zoneId"
                    [multiselect]="false"
                    [allSelectedOption]="false"
                    [treeViewSelect]="false"
                ></app-dropdown-selector>
            </div>
        </div>

        <div class="d-flex align-items-center justify-content-between w-100">
            <div *ngIf="hasMessage; else noMessage">
                <div
                    [ngClass]="{
                        'message-error': hasError,
                        'message-success': !hasError
                    }"
                >
                    <img
                        appImageSelector
                        [imageKey]="hasError ? 'error-circle' : 'check-circle'"
                        imageType="icon"
                        alt="mt"
                    />{{ message }}
                </div>
            </div>
            <ng-template #noMessage>
                <div>
                    
                </div>
            </ng-template>

            <div class="buttons d-flex gap-2">
                <app-button
                    text="cancel"
                    class="cancel shadowed"
                    (clickHandler)="cancel()"
                ></app-button>
                <app-button
                    text="change status"
                    [disabled]="btnDisabled"
                    class="action shadowed"
                    (clickHandler)="updateParkZone()"
                ></app-button>
            </div>
        </div>
    </form>
</div>
